import { useMemo, useState } from "react";
import { Container, Button, InputGroup, Input } from "reactstrap";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteClickHandler,
  extractStaffData,
  modalHandler,
  onEditClickHandler,
  setCurrentPageStaff,
} from "./AddNamePDD/AddPDDMethods/AddNamePDDModalMethods";
import { handleAdminStaffSearch } from "./NamePDDMethods";
import AddNamePDD from "./AddNamePDD";
import { getOfficeList } from "../../../../../Api/AdminApis";
import CardsWithTable from "../../../../../Components/Containers/CardsWithTable";
import ModalContainer from "../../../../../Components/Containers/ModalContainer/ModalContainer";
import { generateBreadcrumb } from "../../../../../Components/BreadCrum/BreadCrum";

const NamePDDIndex = () => {
  const { currentPage = "1" } = useParams();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false); // Add doctor modal
  const [modalEditData, setModalEditData] = useState<any>([]); // data for edit modal
  const [searchQuery, setSearchQuery] = useState<string>("");
  const {
    data: staff,
    error: staffError,
    isLoading: staffLoading,
    refetch: staffListRefetch,
  }: any = useQuery(
    [`staff${currentPage + searchQuery}`, currentPage, searchQuery],
    () => getOfficeList(currentPage, searchQuery),
    { keepPreviousData: true }
  );

  const staffData = useMemo(() => extractStaffData(staff), [staff]);
  const breadcrumbItems = [
    { label: "Settings", link: "/admin/settings" },
    { label: "Prescription Management", link: "/admin/prescription-settings" },
    { label: "NAME OF PEST/DISEASE/DEFICIENCY", link: "/admin/name-pdd" },
  ];
  const breadcrumb = generateBreadcrumb(breadcrumbItems);
  return (
    <section>
      <div className="breadcrumb-wrap">{breadcrumb}</div>
      <div className="content-outer-wrap">
        <Container>
          <div className="search-bar-full-wrap">
            <div className="search-bar">
              <InputGroup>
                <Input
                  placeholder="Search here..."
                  onChange={(e) =>
                    handleAdminStaffSearch(e, setSearchQuery, navigate)
                  }
                />
                <span className="icon-container">
                  <i className="icon xl icon-search"></i>
                </span>
              </InputGroup>
            </div>
            <div className="right-side-wrap">
              <div className="filter-wrap">
                <div className="button-wrap">
                  <Button
                    onClick={() => modalHandler(setModalEditData, setIsOpen)}
                    color="primary"
                    className="sm"
                  >
                    <i className="icon icon-add-new xl"></i>Add Name of
                    PEST/DISEASE/DEFICIENCY
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Container>
        {/* cards section */}
        <div className="content-list-outer-wrap">
          <CardsWithTable
            data={staffData}
            tableTitle="NAME OF PEST/DISEASE/DEFICIENCY DETAILS"
            tableFields={[
              "Name",
              "District",
              "Phone number",
              "Location",
              "Seat Count",
              "Vacant Seat",
            ]}
            Arraykeys={[
              "name",
              "mobile",
              "gender",
              "email",
              "department",
              "designation",
            ]}
            viewType="table"
            toURL={""}
            actions={["edit", "delete"]}
            isLoading={staffLoading}
            error={staffError}
            onEditClick={(selectedId: any) =>
              onEditClickHandler(selectedId, setModalEditData, setIsOpen, staff)
            }
            onDeleteClick={(selectedId: string | number) =>
              deleteClickHandler(selectedId, staffListRefetch)
            }
            paginationData={staff?.meta}
            setCurrentPage={(pageNo: string) =>
              setCurrentPageStaff(navigate, pageNo)
            }
          />
        </div>
      </div>

      <ModalContainer
        isOpen={isOpen}
        setIsopen={setIsOpen}
        title={
          modalEditData?.length !== 0
            ? "Edit Name of PEST/DISEASE/DEFICIENCY"
            : "Add Name of PEST/DISEASE/DEFICIENCY"
        }
      >
        <AddNamePDD
          setIsOpen={setIsOpen}
          modalEditData={modalEditData}
          refetch={staffListRefetch}
        />
      </ModalContainer>
    </section>
  );
};

export default NamePDDIndex;
